import React from 'react';
import MenuMain from '../../MenuMain';
import { FormPlanejamento } from '../../components/FormPlanejamento';
import { AppFooter } from '../../AppFooter';


export default function CadastrarPlanejamentoPage() {

  const defaultValues = {
    'titulo': '',
    'descricao': '',
    'tipo': '',
    'tipos': ['TEORIA','INSTRUMENTO'],
    'turmaId': '',
  }

  return (
    <div>
      <MenuMain>
         <FormPlanejamento
          defaultValues={defaultValues}
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}
